<template lang="pug">
	div.container-fluid
		.row
			.col-xs-12.col-sm-12.col-md-4.col-lg-2.col-xl-2
				.card
					.card-header.bg-info.text-white
						span.fa.fa-filter.mr-2
						| Selecciona
					.card-body
						.form-group
							label
								b Año
							input.form-control(v-model.number="filtro.ano")
						.form-group
							label
								b Agente
							input-query(
								v-if="!filtro.AgenteID"
								input-class="form-control"
								placeholder="Busca agente"
								url="objetivos-agentes/php/api/buscaAgente.php"
								:realtime="true"
								@selected="seleccionaAgente($event)"
							)
							.input-group(v-else)
								input.form-control(disabled, :value="filtro.AgenteNombre")
								.input-group-append
									button.btn.btn-danger(@click="filtro.AgenteID = null")
										span.fa.fa-trash
					.card-footer
						button.btn.btn-sm.btn-primary(@click="getObjetivos", :disabled="!filtro.AgenteID || !filtro.ano")
							span.fa.fa-search.mr-2
							| Ver objetivos

			.col-xs-12.col-sm-12.col-md-8.col-lg-10.col-xl-10
				.card
					.card-header.bg-warning.text-dark
						span.fa.fa-calculator.mr-2
						| Objetivos Soportes
					.tablaObjetivos
						.soporte
							.nombreSoporte Soporte
							.mes Ene
							.mes Feb
							.mes Mar
							.mes Abr
							.mes May
							.mes Jun
							.mes Jul
							.mes Ago
							.mes Sep
							.mes Oct
							.mes Nov
							.mes Dic
							.mes.text-right.p-1 Total
						.soporte(
							v-for="(sop, s) in objetivos.soportes"
						)
							.nombreSoporte {{sop.SoporteNombre}}
							.mes(
								v-for="(mes, i) in sop.meses"
							)
								input.inpObjetivo(placeholder="0", @blur="asignarSoporte(sop, i, $event)", v-model.number="objetivos.soportes[s].meses[i]", :disabled="filtro.ano < new Date().getFullYear()")
							.mes.text-right.p-1 {{total(sop) | currency('')}} €

				.card
					.card-header.bg-danger.text-white
						span.fa.fa-calculator.mr-2
						| Objetivos Partidas
					.tablaObjetivos
						.soporte
							.nombreSoporte Partida
							.mes Ene
							.mes Feb
							.mes Mar
							.mes Abr
							.mes May
							.mes Jun
							.mes Jul
							.mes Ago
							.mes Sep
							.mes Oct
							.mes Nov
							.mes Dic
							.mes.text-right.p-1 Total
						.soporte(
							v-for="(par, s) in objetivos.partidas"
						)
							.nombreSoporte {{par.PartidaNombre}}
							.mes(
								v-for="(mes, i) in par.meses"
							)
								input.inpObjetivo(placeholder="0", @blur="asignarPartida(par, i, $event)", v-model.number="objetivos.partidas[s].meses[i]", :disabled="filtro.ano < new Date().getFullYear()")
							.mes.text-right.p-1 {{total(par) | currency('')}} €
</template>

<script>
import axios from 'axios'
export default {
	data () {
		return {
			filtro: {
				ano: new Date().getFullYear(),
				AgenteID: null,
				AgenteNombre: null
			},
			objetivos: {}
		}
	},
	watch: {
		'filtro.ano': function (newVal) {
			this.objetivos = []

			if (this.filtro.ano && this.filtro.AgenteID) {
				this.getObjetivos()
			}
		},
		'filtro.AgenteID': function (newVal) {
			this.objetivos = []
			if (this.filtro.ano && this.filtro.AgenteID) {
				this.getObjetivos()
			}
		}
	},
	methods: {
		total (sop) {
			const suma = sop.meses.reduce((ant, actual) => {
				ant = ant + actual
				return ant
			}, 0)
			return suma
		},
		seleccionaAgente (ev) {
			this.filtro.AgenteID = ev.datos.ID
			this.filtro.AgenteNombre = ev.texto
		},
		getObjetivos () {
			const form = {
				ano: this.filtro.ano,
				AgenteID: this.filtro.AgenteID
			}
			axios.post('objetivos-agentes/php/api/get.php', form)
				.then(res => {
					this.objetivos = res.data
				})
				.catch(e => {
					console.error(e)
				})
		},
		asignarSoporte (soporte, mes, ev) {
			let importe = parseFloat(ev.target.value)
			if (typeof importe !== 'number') {
				importe = 0
			}

			if (!importe) {
				importe = 0
			}
			const form = {
				SoporteID: soporte.SoporteID,
				mes: mes,
				importe: importe,
				ano: this.filtro.ano,
				AgenteID: this.filtro.AgenteID
			}
			axios.post('objetivos-agentes/php/api/setSoporte.php', form)
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: 'Error guardando el objetivo'
					})
				})
		},

		asignarPartida (partida, mes, ev) {
			let importe = parseFloat(ev.target.value)
			if (typeof importe !== 'number') {
				importe = 0
			}

			if (!importe) {
				importe = 0
			}
			const form = {
				PartidaID: partida.PartidaID,
				mes: mes,
				importe: importe,
				ano: this.filtro.ano,
				AgenteID: this.filtro.AgenteID
			}

			axios.post('objetivos-agentes/php/api/setPartida.php', form)
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: 'Error guardando el objetivo'
					})
				})
		}
	}
}
</script>


<style scoped>
.tablaObjetivos {
	display: flex;
	position: relative;
	flex-direction: column;
	flex-wrap: nowrap;
	width: 100%;
	align-self: stretch;
	align-items: stretch;
	align-content: stretch;
}

.soporte > div {
	padding: 3px;
	border: 1px solid #e0e0e0;
}

.soporte:first-of-type > div {
	text-align: center;
	background-color: #f9f9f9;
}
.soporte {
	display: flex;
	flex-direction: row;
	width: 100%;
	flex-grow: 1;
	flex-wrap: nowrap;
	align-content: stretch;
	align-items: stretch;
	flex-basis: 1;
}

.soporte > .nombreSoporte {
	flex-basis: 0;
	flex-grow: 1;
	flex-shrink: 0;
}

.soporte > .mes {
	flex-basis: 0;
	flex-grow: 1;
	flex-shrink: 0;
	padding: 0;
}

.inpObjetivo {
	position: relative;
	display: block;
	width: 100%;
	border: none;
	padding: 3px;
	margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/modulos/objetivos-agentes/vue/main.vue